module.exports = __webpack_public_path__ + "images/help_v2/masthead_guides-6768568144b58505a689bfb66b91dd21.png";